import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { VariantsDiscountFormInput } from './input-form.component';

export default [
    registerFormInputComponent(
        'variants-discount-form-input',
        VariantsDiscountFormInput
    ),
];
